import vueComponentOptions from 'components/InputUnique.vue';

const UniqueInput = Vue.extend(vueComponentOptions);

module.exports = UniqueInput;
